/** 弹窗内容区宽度：414 设计稿下 320px */
export const MODAL_CONTENT_WIDTH_DESIGN = {
  viewport: 414,
  width: 320,
  narrowViewport: 320,
  narrowVw: 90,
} as const;

const { viewport, width, narrowViewport, narrowVw } = MODAL_CONTENT_WIDTH_DESIGN;
const WIDTH_RATIO = width / viewport;

/** PC 壳固定宽（与 common.css .h5-shell--pc 一致） */
const PC_SHELL_WIDTH = 430;

/** APP 壳最大宽（与 common.css .h5-shell--app 一致） */
const APP_SHELL_MAX_WIDTH = 1400;

function shellHasClass(className: string): boolean {
  if (typeof document === 'undefined') return false;
  return !!document.getElementById('h5-shell')?.classList.contains(className);
}

/** 是否处于 PC 430×932 手机壳（与 App.tsx isPcShellViewport 同阈值） */
function isPcShell(): boolean {
  return shellHasClass('h5-shell--pc');
}

/** APP WebView 壳：宽高跟屏幕，宽最多 1400 */
function isAppShell(): boolean {
  return shellHasClass('h5-shell--app');
}

/**
 * 读取当前视口宽（SSR 回退设计稿视口 414）
 * - PC 壳：按 #h5-shell 实际宽（430）计算，不用 window.innerWidth
 * - APP 壳：按壳实际宽，不超过 1400
 * - 真机 / 窄屏：window.innerWidth
 */
export function getViewportWidth(): number {
  if (typeof window === 'undefined') return viewport;
  const shell = typeof document !== 'undefined' ? document.getElementById('h5-shell') : null;
  const measured = shell?.clientWidth || 0;
  if (isPcShell()) {
    return measured || PC_SHELL_WIDTH;
  }
  if (isAppShell()) {
    return measured || Math.min(window.innerWidth, APP_SHELL_MAX_WIDTH);
  }
  return window.innerWidth;
}

/**
 * 计算弹窗内容区宽度（用于 style.width）
 * - 屏幕 < 320：90vw
 * - 屏幕 ≥ 320：max(320px, 视口宽 × 320/414)
 */
export function getModalContentWidth(viewportWidth = getViewportWidth()): string {
  if (viewportWidth < narrowViewport) {
    return `${narrowVw}vw`;
  }
  const px = Math.max(width, Math.round(viewportWidth * WIDTH_RATIO));
  return `${px}px`;
}
